import {z} from 'zod';

export const mandatoryFieldsFormSchema = z.object({
  fields: z.record(
    z.string(),
    z.object({
      isEnabled: z.boolean().optional(),
      stages: z
        .record(
          z.string(),
          z
            .union([z.string(), z.array(z.any())])
            .optional()
            .nullable()
        )
        .optional(),
    })
  ),
});

export const mandatoryFieldsRequestSchema = z.object({
  mandatoryFields: z.array(
    z.object({
      fieldId: z.string(),
      stageId: z.string(),
    })
  ),
});

export type MandatoryFieldsRequestFormSchemaType = z.infer<typeof mandatoryFieldsFormSchema>;
export type MandatoryFieldsRequestSchemaType = z.infer<typeof mandatoryFieldsRequestSchema>;
